import { AfterViewChecked, Directive } from '@angular/core';
import { LatinizeService } from '../services/latinize.service';
import { FilterService } from 'primeng/api';

@Directive({
	standalone: true,
	selector: 'p-table[appCustomTableFilters], p-treeTable[appCustomTreeTableFilters]',
})
export class CustomTableFiltersDirective implements AfterViewChecked {

	constructor(protected latinizeService: LatinizeService, protected filterService: FilterService) {
	}

	ngAfterViewChecked() {
		const latinize = this.latinizeService.latinize.bind(this.latinizeService);
		this.filterService.register('empty', (value, filter) => {
			if (filter) {
				if (value === undefined || value === null) {
					return true;
				}

				return !filter; // this includes when filter equals ''
			}
			else {
				return true;
			}
		});

		this.filterService.register('codeDesignation', (value, filter) => {
			if (filter === undefined || filter === null || filter.trim() === '') {
				return true;
			}
			if (value === undefined || value === null) {
				return false;
			}
			return latinize(value.designation.toUpperCase()).includes(latinize(filter.toUpperCase()))
					|| latinize(value.code.toUpperCase()).startsWith(latinize(filter.toUpperCase()));
		});

		this.filterService.register('codeClientDesignation', (value, filter) => {
			if (filter === undefined || filter === null || filter.trim() === '') {
				return true;
			}
			if (value === undefined || value === null) {
				return false;
			}
			return latinize(value.designation.toUpperCase()).includes(latinize(filter.toUpperCase()))
				|| latinize(value.codeClient.toUpperCase()).startsWith(latinize(filter.toUpperCase()));
		});

		// Filtrage utilisé pour la recherche sur le code client magasin
		this.filterService.register('codeDesignationMagasin', (value, filter) => {
			if (filter === undefined || filter === null || filter.trim() === '') {
				return true;
			}
			if (value === undefined || value === null) {
				return false;
			}
			return latinize(value.designation.toUpperCase()).includes(latinize(filter.toUpperCase()))
					|| latinize(value.code.toUpperCase()).includes(latinize(filter.toUpperCase()));
		});

		this.filterService.register('texte', (value, filter) => {
			if (filter === undefined || filter === null || filter.trim() === '') {
				return true;
			}
			if (value === undefined || value === null) {
				return false;
			}
			value = '' + value;
			return latinize(value.toUpperCase()).includes(latinize(filter.toUpperCase()));
		});

		this.filterService.register('codeDesignationStrict', (value, filter) => {
			if (filter === undefined || filter === null) {
				return true;
			}
			if (value === undefined || value === null) {
				return false;
			}
			const check = (v, f) => latinize(v.code.toUpperCase()) === latinize(f.code.toUpperCase())
					&& latinize(v.designation.toUpperCase()) === latinize(f.designation.toUpperCase());

			if (Array.isArray(filter)) {
				for (const filtreCourant of filter) {
					if (check(value, filtreCourant)) {
						return true;
					}
				}
				return false;
			}
			else {
				return check(value, filter);
			}
		});

		// Effectue l'intersection entre la liste des valeurs à filtrer et la liste des valeurs avec code de la ligne
		this.filterService.register('intersectionCode', (valeurs: any[], valeursFiltrees: any[]): boolean => {
			if (valeursFiltrees === undefined || valeursFiltrees === null || valeursFiltrees.length === 0) {
				return true;
			}
			if (valeurs === undefined || valeurs === null || valeurs.length === 0) {
				return false;
			}
			let matchFiltre = false;
			for (const valeur of valeurs) {
				if (valeursFiltrees.some(valeurFiltree => valeurFiltree.code === valeur.code)) {
					matchFiltre = true;
					break;
				}
			}
			return matchFiltre;
		});

		this.filterService.register('listeCodeOuDesignationStrictContains', (values, filter) => {
			if (filter === undefined || filter === null) {
				return true;
			}
			if (values === undefined || values === null) {
				return false;
			}
			const check = (v, f) => latinize(v.code.toUpperCase()) === latinize(f.toUpperCase())
				|| latinize(v.designation.toUpperCase()) === latinize(f.toUpperCase());

			if (!Array.isArray(filter)) {
				filter = [filter];
			}

			for (const filtreCourant of filter) {
				if (Array.isArray(values)) {
					for (const value of values) {
						if (check(value, filtreCourant)) {
							return true;
						}
					}
				}
				else {
					if (check(values, filtreCourant)) {
						return true;
					}
				}
			}
			return false;
		});

		this.filterService.register('listeCodeDesignationStrictContains', (values, filter) => {
			if (filter === undefined || filter === null || (Array.isArray(filter) && filter.length === 0) ) {
				return true;
			}
			if (values === undefined || values === null) {
				return false;
			}
			const check = (v, f) => latinize(v.code.toUpperCase()) === latinize(f.code.toUpperCase())
				&& latinize(v.designation.toUpperCase()) === latinize(f.designation.toUpperCase());

			if (!Array.isArray(filter)) {
				filter = [filter];
			}

			for (const filtreCourant of filter) {
				if (Array.isArray(values)) {
					for (const value of values) {
						if (check(value, filtreCourant)) {
							return true;
						}
					}
				}
				else {
					if (check(values, filtreCourant)) {
						return true;
					}
				}
			}
			return false;
		});

		// Filtre booléen permettant d'éliminer les valeurs vides ou non :
		// - Si filter est à true, on ne garde que les valeurs définies
		// - Si filter est à false, on ne filtre pas
		this.filterService.register('notBlankOrUnchecked', (value: any, filter: boolean) => {
			let resultat = !filter;
			if (typeof(value) === 'boolean') {
				resultat = resultat || value === false;
			}
			else {
				resultat = resultat || value != null && String(value).trim() !== '';
			}

			return resultat;
		});
	}
}
